import { createAuthClient } from "better-auth/react";

/** Local dev only: the server refuses to start with DEV_NO_AUTH in production. */
export const NO_AUTH = import.meta.env.VITE_DEV_NO_AUTH === "1";

export const authClient = createAuthClient({ basePath: "/api/auth" });

export const safeRedirect = (to?: string) => (to && to.startsWith("/") && !to.startsWith("//") ? to : "/");
